import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 关闭蓝牙模块
export function closeBluetoothAdapter(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(
    APINames.Native.CLOSE_BLUETOOTH_ADAPTER,
    option
  );
}
